import { apiClient } from '../config';
import { endpoints } from '../endpoints';

/**
 * Service for fetching statistics data from the API
 */
export const statisticsService = {
  /**
   * Get dashboard statistics for the public home page
   * @returns {Promise<Object>} Dashboard statistics including publishedPapers, activeResearchers, researchFields, and featuredManuscripts
   */
  getDashboardStatistics: async () => {
    try {
      const response = await apiClient.get(endpoints.statistics.dashboard);
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard statistics:', error);
      throw error;
    }
  },

  /**
   * Get dashboard statistics for the public home page
   * @returns {Promise<Object>} Dashboard statistics including publishedPapers, activeResearchers, researchFields, and featuredManuscripts
   */
  getPublicStatistics: async () => {
    try {
      const response = await apiClient.get(endpoints.statistics.public);
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard statistics:', error);
      throw error;
    }
  },

  /**
   * Get detailed statistics for a specific journal
   * @param {string} journalId - UUID of the journal
   * @returns {Promise<Object>} Journal statistics including totalManuscripts, publishedManuscripts, etc.
   */
  getJournalStatistics: async (journalId) => {
    try {
      const response = await apiClient.get(endpoints.statistics.journal(journalId));
      return response.data;
    } catch (error) {
      console.error(`Error fetching statistics for journal ${journalId}:`, error);
      throw error;
    }
  }
};
